import React, { useEffect, useState } from 'react';
import { log } from '../../common/common';
import RelatedCard from '../cards/sideBarCards/relatedCard/RelatedCard';
import RelatedSpqCard from '../cards/sideBarCards/relatedCard/RelatedSpqCard';
import RelatedGrCard from '../cards/sideBarCards/relatedCard/RelatedGrCard';
import { useDispatch } from 'react-redux';
import { fetchRelatedContent } from '../../Store/actions/commonActions';
import RelatedSessionCard from '../cards/sideBarCards/relatedCard/RelatedSessionCard';
import RelatedClVideoCard from '../cards/sideBarCards/relatedCard/RelatedClVideoCard';
import useRedirect from '../customHooks/useRedirect';
import MedwikiRelatedPostLoader from '../../skeleton/medwiki/MedwikiDetailsV2/MedwikiRelatedPostLoader';
import InView from 'react-intersection-observer';
import { useTrackUserActivity } from '../customHooks/useTrackUserActivity';
let pagination = 0;
const RightRelated = ({
  pageType,
  content_id,
  clickRelatedCard,
  speciality_id,
  gtmTagVariable = ''
}) => {
  const dispatch = useDispatch();
  const { redirectTo } = useRedirect();
  const [relatedLoader, setRelatedLoader] = useState(true);
  const [relatedData, setRelatedData] = useState([]);
  const [explore, setExplore] = useState(true);
  const getRelatedData = () => {
    dispatch(
      fetchRelatedContent(content_id, speciality_id, pagination, 5, (res) => {
        if (res != 'error') {
          log('RESP', res.data);
          setRelatedLoader(false);
          res.data.length > 0
            ? setRelatedData((prev) => {
                return [...prev, ...res.data];
              })
            : setExplore(false);
        }
      })
    );
  };
  useEffect(() => {
    content_id && getRelatedData();
    return () => {
      pagination = 0;
    };
  }, [content_id]);
  const renderCard = (type, _rel) => {
    switch (type) {
      case 'comp':
        return (
          <RelatedCard
            gtmTagVariable={`gtm_cl_rightRelated`}
            data={_rel}
            click={() =>
              pageType == type
                ? clickRelatedCard(_rel.type_id, _rel.question)
                : redirectTo('MedwikiDetails', _rel.type_id, _rel.question)
            }
          />
        );
      case 'survey':
        return (
          <RelatedSpqCard
            gtmTagVariable={`gtm_cl_rightRelated`}
            data={_rel}
            click={() => {
              pageType == type
                ? clickRelatedCard(_rel.survey_id, _rel.survey_title, _rel.category)
                : _rel.category == 'poll'
                ? redirectTo('PollDetails', _rel.survey_id, _rel.survey_title)
                : redirectTo('SPQdetails', _rel.survey_id, _rel.survey_title);
            }}
          />
        );
      case 'gr':
        return (
          <RelatedGrCard
            gtmTagVariable={`gtm_cl_rightRelated`}
            data={_rel}
            click={() => {
              redirectTo('GrandRoundDetails', _rel.type_id, _rel.title);
            }}
          />
        );
      case 'session':
        return (
          <RelatedSessionCard
            gtmTagVariable={`gtm_cl_rightRelated`}
            data={_rel}
            click={() => {
              redirectTo('SessionDetails', _rel.session_id, _rel.session_topic);
            }}
          />
        );
      case 'video_archive':
        return (
          <RelatedClVideoCard
            gtmTagVariable={`gtm_cl_rightRelated`}
            data={_rel}
            click={() =>
              pageType == type
                ? clickRelatedCard(_rel.type_id, _rel.question)
                : redirectTo('ClinicalVideoDetails', _rel.type_id, _rel.question)
            }
          />
        );
      default:
        break;
    }
  };

  const getParentClassId = () => {
    if (pageType == 'video_archive') {
      return 'clinical_videos_related';
    } else if (pageType == 'comp') {
      return 'medwiki_related';
    } else if (pageType == 'survey') {
      return 'spq_details_related';
    } else {
      return 'default_class_right_related';
    }
  };

  const getExploreBtnId = () => {
    if (pageType == 'video_archive') {
      return 'clinical_videos_related_explore_more';
    } else if (pageType == 'comp') {
      return 'medwiki_related_explore_more';
    } else if (pageType == 'survey') {
      return 'survey_related_explore_more';
    } else {
      return 'default_class_right_related_explore_more';
    }
  };

  const { userActivityTracker } = useTrackUserActivity();
  return (
    <>
      {!relatedLoader && relatedData?.length > 0 ? (
        <div
          className="w-100 detailsTrnding d-flex flex-column border border-light"
          id={getParentClassId()}
        >
          <div className="detailsTrndingTtl p-3 border-bottom border-light">
            <h2 className="fs-3 text-black text-start">Related</h2>
          </div>
          <div className="w-100 float-start detailsTrndingCardArea p-3">
            {relatedData &&
              relatedData?.map((_rel, index) => {
                return (
                  <InView
                    key={index + 1}
                    as="div"
                    onChange={(inView) => {
                      userActivityTracker(inView, _rel, 'card', content_id);
                    }}
                  >
                    <div className="w-100 detailsTrndingCard cursorPointer mb-3">
                      {renderCard(_rel.trending_type || _rel.type, _rel)}
                    </div>
                  </InView>
                );
              })}
          </div>
          {explore && (
            <div className="w-100 float-start">
              <a
                href="javascript:void(0)"
                className={`fs-4 fw-medium detailsTrndingMore_a rippleEffect text-secondary d-block border-top border-light p-3 text-center gtm_cl_rightRelated_explore_more`}
                onClick={() => {
                  pagination += 5;
                  getRelatedData();
                }}
                id={getExploreBtnId()}
              >
                Explore More
              </a>
            </div>
          )}
        </div>
      ) : relatedLoader ? (
        <MedwikiRelatedPostLoader />
      ) : null}
    </>
  );
};

export default RightRelated;
